// 1/2 Fast Mobile Keys - brand data

export const businessInfo = {
  name: "1/2 Fast Mobile Keys",
  owner: "Shane Shannon",
  tagline: "Fast, Affordable Mobile Key Replacement \u2014 We Come to You.",
  catchphrase:
    "Getting you the keys you need in half the time and at half the cost of the dealerships.",
  phone: "(606) 331-7393",
  phoneRaw: "+16063317393",
  email: "halffastmobilekeys@gmail.com",
  city: "Louisa",
  state: "KY",
  serviceRegion: "Louisa, KY & the Tri-State Area",
  hours: "Open 24 Hours",
  yearsInBusiness: 8,
  yelpUrl: "https://m.yelp.com/biz/1-2-fast-mobile-keys-louisa",
  yelpReviewUrl:
    "https://www.yelp.com/writeareview/biz/MtVpkTrQ-xdihtM1I7EvSg?review_origin=biz_details_war_button",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_rapid-unlock-service/artifacts/swiuo1yl_file_00000000615471fdadc5133ae4a42be7.png",
  cardUrl:
    "https://customer-assets.emergentagent.com/job_rapid-unlock-service/artifacts/bzqi4tb6_Screenshot_20260512_133926_Gallery.jpg",
  priceSheetUrl:
    "https://customer-assets.emergentagent.com/job_rapid-unlock-service/artifacts/bnvve3y4_file_0000000038b471f78a404ef3c000c429.png",
  description:
    "Automotive Key Replacement, Diagnostics, Module Programming & Cloning, plus basic mobile maintenance. Always on call for an emergency \u2014 I'm able to come to you. Guaranteed to beat dealership prices.",
};

export const services = [
  {
    id: 1,
    icon: "KeyRound",
    title: "Automotive Key Replacement",
    description:
      "Lost your car key? I cut and program new keys for nearly every make and model, right at your location.",
    features: ["All makes & models", "On-site cutting", "Beats dealer prices"]
  },
  {
    id: 2,
    icon: "Unlock",
    title: "Lost Key Replacement",
    description:
      "Down to no keys at all? I'll make you a new one on the spot \u2014 no tow truck, no dealership wait.",
    features: ["$180\u2013$300 typical", "No tow needed", "24/7 emergency"]
  },
  {
    id: 3,
    icon: "Cpu",
    title: "Key & Smart Fob Programming",
    description:
      "Remote, transponder, push-to-start and smart keys programmed using professional diagnostic equipment.",
    features: ["Smart keys", "Push-to-start", "Remotes & transponders"]
  },
  {
    id: 4,
    icon: "Wrench",
    title: "Mobile Diagnostics",
    description:
      "Check engine light on? I scan your vehicle and tell you exactly what's wrong before you spend a dime at the shop.",
    features: ["Check engine scans", "Full system scans", "Repair advice"]
  },
  {
    id: 5,
    icon: "Cog",
    title: "Module Programming & Cloning",
    description:
      "Module resets, relearns and cloning for vehicles that need a software fix instead of a part swap.",
    features: ["Module reset/relearn", "Battery registration", "TPMS relearn"]
  },
  {
    id: 6,
    icon: "Copy",
    title: "Spare Key Service",
    description:
      "Add a spare to your keyring before you ever lose one. Cheaper as a backup than as an emergency.",
    features: ["Spare keys", "Smart key spares", "Same-day on site"]
  },
  {
    id: 7,
    icon: "Droplet",
    title: "Oil & Filter Service",
    description:
      "Full oil and filter change in your driveway. Bring your own oil and filter brand of choice, or I'll source what you want \u2014 your car, your call.",
    features: [
      "Your choice of oil brand",
      "Your choice of filter",
      "Done on-site, no shop wait"
    ]
  },
  {
    id: 8,
    icon: "Disc",
    title: "Brakes, Rotors & Filters",
    description:
      "Brake pad and rotor replacement, plus engine air filters and cabin air filters. Honest pricing, no upsells \u2014 just the work your vehicle actually needs.",
    features: [
      "Brake pads & rotors",
      "Engine air filters",
      "Cabin air filters"
    ]
  },
  {
    id: 9,
    icon: "Car",
    title: "Other Basic Maintenance",
    description:
      "Battery swaps, bulb replacement, wiper blades, fluid top-offs and more. If it can be done in a driveway, there's a good chance I can do it \u2014 just call and ask.",
    features: ["Battery & bulbs", "Wipers & fluids", "Call to ask about more"]
  }
];

export const priceSheet = [
  {
    section: "Diagnostics",
    icon: "Car",
    rows: [
      { name: "Check Engine Light Scan", price: "$40" },
      { name: "Full System Diagnostic Scan", price: "$60" },
      { name: "Diagnostic + Repair Advice", price: "$80" }
    ]
  },
  {
    section: "Key Programming",
    icon: "KeyRound",
    rows: [
      { name: "Program Customer-Supplied Key", price: "$80" },
      { name: "Program Customer-Supplied Smart Key", price: "$120" },
      { name: "Add Spare Key (Key Included)", price: "$120\u2013$180" },
      { name: "Add Smart Key (Key Included)", price: "$180\u2013$250" }
    ]
  },
  {
    section: "Remote & Key Fob Services",
    icon: "Radio",
    rows: [
      { name: "Key Fob Programming", price: "$60" },
      { name: "Remote Programming", price: "$50\u2013$80" },
      { name: "Universal Remote Setup", price: "$80\u2013$120" }
    ]
  },
  {
    section: "Lost Key Services",
    icon: "Unlock",
    rows: [
      { name: "Lost Key Replacement", price: "$180\u2013$300" },
      { name: "Lost Smart Key Replacement", price: "$250\u2013$450" }
    ]
  },
  {
    section: "Additional Services",
    icon: "Cog",
    rows: [
      { name: "Module Reset / Relearn", price: "$80" },
      { name: "Battery Registration", price: "$60" },
      { name: "TPMS Relearn", price: "$40" }
    ]
  },
  {
    section: "Mobile Service",
    icon: "MapPin",
    rows: [
      { name: "Local Service Call", price: "$25" },
      { name: "10\u201325 Miles", price: "$40" }
    ]
  },
  {
    section: "Mobile Maintenance",
    icon: "Wrench",
    rows: [
      { name: "Oil & Filter Change", price: "Call / Msg" },
      { name: "Brake Pads & Rotors", price: "Call / Msg" },
      { name: "Engine & Cabin Air Filters", price: "Call / Msg" },
      { name: "Battery, Bulbs, Wipers, Fluids", price: "Call / Msg" }
    ]
  }
];

export const payments = [
  "Cash",
  "All Major Credit Cards",
  "Cash App",
  "PayPal",
  "Venmo"
];

export const reviews = [
  {
    id: 1,
    name: "Jessica M.",
    location: "Louisa, KY",
    rating: 5,
    date: "1 week ago",
    text:
      "Locked my keys in the car at the grocery store with my baby inside. Shane was there in under 15 minutes. Got us in with no damage. Lifesaver \u2014 literally!"
  },
  {
    id: 2,
    name: "Ricky T.",
    location: "Inez, KY",
    rating: 5,
    date: "3 weeks ago",
    text:
      "Ford dealer quoted me $480 for a replacement key. Shane did it in my driveway for less than half that, programmed and all. Fast, friendly and fair."
  },
  {
    id: 3,
    name: "Amanda S.",
    location: "Prestonsburg, KY",
    rating: 5,
    date: "4 weeks ago",
    text:
      "Check engine light came on right before a road trip. He scanned it, told me it was just a loose gas cap, and saved me hundreds. Honest guy."
  },
  {
    id: 4,
    name: "Dakota W.",
    location: "Paintsville, KY",
    rating: 5,
    date: "4 months ago",
    text:
      "Needed a spare smart key for my Silverado. Came to my work, had it cut and programmed in 20 minutes. Way cheaper than Chevy wanted."
  },
  {
    id: 5,
    name: "Brittany L.",
    location: "Louisa, KY",
    rating: 5,
    date: "6 weeks ago",
    text:
      "Called at 11 pm after losing my only key. He answered, drove out, and had me back on the road by midnight. Can't recommend enough."
  },
  {
    id: 6,
    name: "Travis H.",
    location: "Ashland, KY",
    rating: 5,
    date: "2 months ago",
    text:
      "Professional, knew exactly what he was doing, and the price was right. Will be using him for any future key or lock needs."
  }
];

export const serviceAreas = [
  "Louisa",
  "Inez",
  "Paintsville",
  "Prestonsburg",
  "Ashland",
  "Catlettsburg",
  "Pikeville",
  "Huntington, WV",
  "Ironton, OH",
  "Greenup"
];

export const whyChooseUs = [
  {
    icon: "Clock",
    title: "24/7 Availability",
    text: "Day or night, weekend or holiday \u2014 Shane answers and comes to you."
  },
  {
    icon: "Truck",
    title: "Fully Mobile",
    text: "Equipped van means the shop comes to your driveway or roadside."
  },
  {
    icon: "BadgeDollarSign",
    title: "Half the Dealer Cost",
    text: "Guaranteed lower than the dealership on nearly every job."
  },
  {
    icon: "Star",
    title: "5-Star Rated",
    text: "Trusted by drivers across the Tri-State for fast, honest service."
  }
];
